module.exports = __webpack_public_path__ + "static/mv01-df274e94ac4b1ae798b9a1c17ea0b72b.jpg";